import './App.css';
import {
    Route,
    createBrowserRouter,
    createRoutesFromElements
} from "react-router-dom";
import Login from './login/';
import ProtectedLayout from './protectedLayout'
import NotFound from './notFound';
import Users from './users';
import UserInvites from './users/userInvites';
import Dashboard from './dashboard'
import Events from './events';
import EventDetails from './events/evenDetails';

export const router = createBrowserRouter(
    createRoutesFromElements(
        <Route>
            <Route>
                <Route element={<ProtectedLayout page={<Users/>} title={'Users'}/>} path="/users"/>
                <Route element={<ProtectedLayout page={<Dashboard/>} title={'Dasboard'}/>} path="/dashboard"/>
                <Route element={<ProtectedLayout page={<UserInvites/>} title={'Invited Users'}/>}  path="/users/:userId/invites"> </Route>
                <Route element={<ProtectedLayout page={<Events/>} title={'Events'}/>}  path="/events/"> </Route>
                <Route element={<ProtectedLayout page={<EventDetails/>} title={'Event details'}/>}  path="/events/:uid"> </Route>
            </Route>
            <Route element={<Login/>} path="/"/>
            <Route path="*" element={<ProtectedLayout page={<NotFound/>}/>}/>
        </Route>
    )
);

